module.exports = __webpack_public_path__ + "static/img/main_round.0928eecc.png";